/**
 * Section Api
 */
// Section 생성
export async function setCreateSection(app, mtId, stType, stTitle, stCreatedAt, stCreatorUid) {
  return await app.$axios.post('/v1/section/create', {
    mtId,
    stType,
    stTitle,
    stCreatedAt,
    stCreatorUid,
  })
}
// Section 업데이트
export async function setUpdateSection(app, stId, mtId, stTitle) {
  return await app.$axios.post('/v1/section/update', {
    stId,
    mtId,
    stTitle,
  })
}

// Follow Up 클립 생성
export async function setDeleteSection(app, wsId, stId, mtId) {
  return await app.$axios.post('/v1/section/delete', {
    wsId,
    stId,
    mtId,
  })
}
